import { sendPasswordResetEmail } from 'firebase/auth'
import { auth } from '../firebase'
import { api } from './apiClient'
import { invitePortalUser, PASSWORD_SETUP_CONTINUE_URL } from './userInvitationFlow.mjs'

export function sendUserPasswordEmail(email) {
  return sendPasswordResetEmail(auth, email, { url: PASSWORD_SETUP_CONTINUE_URL })
}

export function inviteUser(input) {
  return invitePortalUser(input, { createUser: api.createUser, sendEmail: sendUserPasswordEmail })
}
